const ADD_WIDGET = "widget/ADD_WIDGET";


export default {
    ADD_WIDGET
};



// WEBPACK FOOTER //
// ./dev/ducks/widget/types.js